<template>
    <b-input-group-text v-bind="$props">
        <slot />
    </b-input-group-text>
</template>

<script>
import { BInputGroupText } from 'bootstrap-vue'

export default {
    components: { BInputGroupText },
}
</script>